import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = ({ lang }) => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: lang.NAV_HOME || 'Home', path: '/home' },
    { label: lang.NAV_ABOUT || 'About', path: '/about' },
    { label: lang.NAV_ACTIVITIES || 'Activities', path: '/activities' },
    { label: lang.NAV_BLOG || 'Blog', path: '/blog' },
    { label: lang.NAV_RECRUITMENT || 'Recruitment', path: '/recruitment' },
  ];

  return (
    <footer className="footer">
      <div className="footer-top-line"></div>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-text">{lang.FOOTER_LOGO || 'ISPCLUB'}</span>
            </div>
            <p className="footer-desc">
              {lang.FOOTER_DESCRIPTION || 'ISP Club - Information Security Club at PTIT.'}
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">{lang.FOOTER_QUICK_LINKS || 'Quick Links'}</h4>
            <ul>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-social-section">
            <h4 className="footer-heading">{lang.FOOTER_SOCIAL || 'Social Media'}</h4>
            <div className="footer-socials">
              <a href={lang.CONTACT_FACEBOOK || '#'} className="footer-social-link" target="_blank" rel="noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href={lang.CONTACT_GITHUB || '#'} className="footer-social-link" target="_blank" rel="noreferrer" aria-label="GitHub">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href={lang.CONTACT_DISCORD || '#'} className="footer-social-link" target="_blank" rel="noreferrer" aria-label="Discord">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-address">
            <h4 className="footer-heading">{lang.FOOTER_ADDRESS_LABEL || 'Address & Contact'}</h4>
            <p>{lang.CONTACT_ADDRESS || 'PTIT, Ha Noi, Viet Nam'}</p>
            <p>{lang.CONTACT_EMAIL || 'ispclub@ptit.edu.vn'}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} {lang.FOOTER_COPYRIGHT || 'ISP Club - Infomation Security PTIT'}.{lang.FOOTER_RIGHTS ? ` ${lang.FOOTER_RIGHTS}` : ''}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
